import { Button2, Group, Stack, Text2, Textarea } from '@el8/vital';
import { LegacyFriendlyDialog } from 'components/overlays';
import React, { useState } from 'react';

interface RestoreDeletedPatientFeedbackDialogProps {
  patientName: string;
  onConfirm: (reason: string) => void;
  onConfirmAndOpen: (reason: string) => void;
  onCancel: () => void;
}

/**
 * Dialog shown before restoring a deleted patient that collects optional
 * feedback about why the chart was accidentally deleted.
 */
export const RestoreDeletedPatientFeedbackDialog = ({
  patientName,
  onConfirm,
  onConfirmAndOpen,
  onCancel,
}: RestoreDeletedPatientFeedbackDialogProps): JSX.Element => {
  const [reason, setReason] = useState('');

  return (
    <LegacyFriendlyDialog
      isOpen
      title="Before you restore..."
      width={480}
      padded
      onClose={onCancel}
      footer={
        <Group>
          <Button2 kind="default" label="Restore" onClick={() => onConfirm(reason)} />
          <Button2
            kind="primary"
            label="Restore and open chart"
            onClick={() => onConfirmAndOpen(reason)}
          />
        </Group>
      }
    >
      <Stack gap="sm">
        <Text2>Why was {patientName}&apos;s chart accidentally deleted?</Text2>
        <Textarea
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder="Optional — your feedback helps us prevent accidental deletions"
          rows={3}
          sizing="sm"
          resize="auto"
        />
      </Stack>
    </LegacyFriendlyDialog>
  );
};
